import { createApp } from "vue";
import { router } from "@/router";
import App from "@/App.vue";
// Silence passive event listener warnings for touch/wheel (Select2, perfect-scrollbar)
import "@/utils/passive-events";
import { BootstrapVue3, BToastPlugin } from "bootstrap-vue-3";
import Antd from "ant-design-vue";
import VueFeather from "vue-feather";
import VueSelect from "vue3-select2-component";
import VueSweetalert2 from "vue-sweetalert2";
import Vue3Toastify from "vue3-toastify";
import VueApexCharts from "vue3-apexcharts";

import $ from "jquery";
window.$ = window.jQuery = $;
import "select2";
import "select2/dist/css/select2.css";

import "ant-design-vue/dist/reset.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "boxicons/css/boxicons.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "pe7-icon/dist/dist/pe-icon-7-stroke.css";
import "typicons.font/src/font/typicons.css";
import "weathericons/css/weather-icons.css";
import "ionicons-npm/css/ionicons.css";
import "@/assets/css/feather.css";
import "@/assets/css/style.css";
import "vue3-toastify/dist/index.css";

import Header from "@/views/layouts/pos-header.vue";
import Sidebar from "@/views/layouts/pos-sidebar.vue";
import UserMenu from "@/views/layouts/user-menu.vue";
import Breadcrumb from "@/components/breadcrumb/layout-breadcrumb.vue";

import ProductHeader from "@/views/pages/inventory/product-list/product-header.vue";

import ManageStocksModal from "@/components/modal/manage-stocks-modal.vue";
import ProductListModal from "@/components/modal/product-list-modal.vue";
import AddProductModal from "@/components/modal/add-product-modal.vue";
import CustomersModal from "@/components/modal/customers-modal.vue";
import EmployeeModal from "@/components/modal/employee-modal.vue";
import BonLivraisonModal from "@/components/modal/bon-livraison-modal.vue";
import WarehouseModal from "@/components/modal/warehouse-modal.vue";
import SalesListModal from "@/components/modal/sales-list-modal.vue";
import InvoicesListModal from "@/components/modal/invoices-list-modal.vue";

import swal from "sweetalert2";
window.Swal = swal;

const app = createApp(App);

app.component("layout-header", Header);
app.component("layout-sidebar", Sidebar);
app.component("user-menu", UserMenu);
app.component("layout-breadcrumb", Breadcrumb);
app.component("product-header", ProductHeader);
app.component("manage-stocks-modal", ManageStocksModal);
app.component("product-list-modal", ProductListModal);
app.component("add-product-modal", AddProductModal);
app.component("customers-modal", CustomersModal);
app.component("employee-modal", EmployeeModal);
app.component("bon-livraison-modal", BonLivraisonModal);
app.component("warehouse-modal", WarehouseModal);
app.component("sales-list-modal", SalesListModal);
app.component("invoices-list-modal", InvoicesListModal);
app.component(VueFeather.name, VueFeather);
app.component("vue-select", VueSelect);
app.component("ApexChart", VueApexCharts);

app
  .use(VueSweetalert2)
  .use(Vue3Toastify, { autoClose: 3000 })
  .use(Antd)
  .use(BootstrapVue3)
  .use(BToastPlugin)
  .use(VueApexCharts);

app.use(router).mount("#app");
